<template>
  <v-autocomplete
    :items="itemsComputed"
    item-text="descricao_full"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="!desativarSelecionarTodos && multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.indexOf(item.id) < qtdeVisivelSelecionados">
        <span>{{item.descricao_full}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import FornecedorAPI from "../../../api/fornecedor"
import {arrayColumn, logout} from "@/helpers";

export default {
  name: "SysFornecedorAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 1
    },
    desativarSelecionarTodos: {
      type: Boolean,
      default: false
    },
    filtroDepartamentos: {
      type: Array,
      default: () => ([])
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    idsGrupo: {
      type: Array,
      default: () => ([])
    },
    idsFilial: {
      type: Array,
      default: () => ([])
    },
    idsSegmento: {
      type: Array,
      default: () => ([])
    },
    idsSecao: {
      type: Array,
      default: () => ([])
    },
    idsComprador: {
      type: Array,
      default: () => ([])
    },
    buscarTodosFornecedores: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null
  }),
  computed: {
    itemsComputed() {
      if (this.unshiftItems && this.unshiftItems.id != null && this.unshiftItems.descricao_full != null) {
        const jaIncluido = this.items.some(item => String(item.id) === String(this.unshiftItems.id));
        return jaIncluido ? this.items : [this.unshiftItems].concat(this.items);
      }
      return this.items;
    },
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  watch: {
    idsGrupo(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsFilial(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSegmento(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSecao(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsComprador(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
  },
  mounted() {
    this.getItems();
  },
  methods: {
    verificaAtualizacaoFiltros(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    updateModel(values) {
      if ([null, undefined].includes(values)) {
        values = this.$attrs.multiple ? [] : '';
      }

      this.$emit('update:modelValue', values)
    },
    getItems () {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()

      const parametros = {
        fornecedores: this.idsFornecedor,
      }

      if (this.buscarTodosFornecedores) {
        FornecedorAPI.getFornecedores(headers, parametros)
        .then((response) => {
          const {token, fornecedores} = response.data;
          localStorage.token = token;

          this.items = fornecedores;
          this.loading = false;

          this.atualizarFiliaisSelecionadas();
        })
        .catch(logout)

        return;
      }

      FornecedorAPI.getFornecedoresEmProdutoFilial(headers, parametros)
        .then((response) => {
          const {token, fornecedores} = response.data;
          localStorage.token = token;

          this.items = fornecedores;
          this.loading = false;

          this.atualizarFiliaisSelecionadas();
        })
        .catch(logout)
    },
    atualizarFiliaisSelecionadas() {
      if (!this.multiplaSelecao || !Array.isArray(this.modelValue)) return;

      const novos_itens = this.items.filter(item => this.modelValue.some(id => `${id}` === `${item.id}`));
      this.updateModel(arrayColumn(novos_itens, 'id'));
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
